/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import * as yup from 'yup';

/**
 * Here mentioned users feature change password validations
 */
const changePasswordValidation = yup.object().shape({
  password: yup
    .string()
    .trim()
    .required('New password is a required field')
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/,
      'New password should contain at least 8 characters with One Uppercase, One Lowercase and One Number'
    ),
  confirmPassword: yup
    .string()
    .trim()
    .required('Confirm Password is a required field')
    .oneOf([yup.ref('password'), null], 'Passwords must match'),
});
//
export default changePasswordValidation;
